(function() {
  function init() {
    var grids = document.querySelectorAll('[class*="ai-quad-banner-grid-"]');
    grids.forEach(function(grid) {
      // Ocultar cards vazios PRIMEIRO
      var items = grid.querySelectorAll('[class*="ai-quad-banner-item-"]');
      var visibleItems = [];
      items.forEach(function(item) {
        var hasPlaceholder = item.querySelector('[class*="ai-quad-banner-placeholder-"]');
        var hasImage = item.querySelector('img');
        var hasVideo = item.querySelector('video');
        if (hasPlaceholder && !hasImage && !hasVideo) {
          item.style.display = 'none';
        } else {
          visibleItems.push(item);
        }
      });

      // Aplicar layout carrossel se configurado
      var container = grid.closest('[class*="ai-quad-banner-container-"]');
      if (!container) return;

      var layout = container.dataset.desktopLayout || 'grid';
      if (layout === 'carousel' && window.innerWidth >= 768) {
        grid.style.cssText = 'display:flex!important;flex-wrap:nowrap!important;overflow-x:auto;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;gap:12px;';
        visibleItems.forEach(function(item) {
          item.style.flex = '0 0 280px';
          item.style.minWidth = '280px';
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
